export default {
  dataDateRange({ commit }, data){
    commit("SET_DATE_RANGE", data)
  }
};